import { useState, useEffect } from "react";
import useApi from "./apiService";

const useResources = ({ admin = false } = {}) => {
  const { fetchData } = useApi();
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!loaded) {
      loadResources();
    }
  }, [loaded]);

  const loadResources = async () => {
    setLoading(true);
    try {
      const response = await fetchData("/resources");
      setResources(response.data);
      setLoaded(true);
      setError(null);
    } catch (err) {
      console.error("Erro ao carregar recursos:", err);
      setError("Erro ao carregar recursos disponíveis");
    } finally {
      setLoading(false);
    }
  };

  const getResourceBySlug = (slug) => {
    return resources.find((res) => res.slug === slug);
  };

  const filteredResources = admin
    ? resources
    : resources.filter((res) => res.slug !== "mappings");

  return {
    resources: filteredResources,
    getResourceBySlug,
    loading,
    error,
    isLoaded: loaded,
    reload: () => setLoaded(false), // Para recarregar se necessário
  };
};

export default useResources;
